import { PluginKey } from '@atlaskit/editor-prosemirror/state';

export const aiQucikstartCommandPluginKey: PluginKey = new PluginKey('aiQucikstartCommand');
